import { getLuminance } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => {
    return {
        banner: ({ bannerColor }) => {
            const bannerTextColor = getLuminance(bannerColor) < 0.5 ? theme.palette.common.white : theme.palette.common.black;
            return {
                backgroundColor: bannerColor,
                color: bannerTextColor,
                padding: theme.spacing(2, 0),
                position: 'relative',
                display: 'block',
                width: '100%',
                '&:hover': {
                    color: bannerTextColor,
                },
            };
        },
        bannerLinkArrow: {
            marginLeft: theme.spacing(1.5),
            verticalAlign: 'middle',
        },
    };
});
